const adminOrderDetailData = {
    en: {
        nav: {
            back: 'Back to Dashboard',
        },
        hero: {
            eyebrow: 'Order Detail',
            shipmentId: 'Shipment ID',
            notFound: 'Order not found',
        },
        meta: {
            customer: 'Customer',
            date: 'Date',
            total: 'Total',
        },
        customer: {
            sectionLabel: 'Customer',
            name: 'Name',
            email: 'Email',
            phone: 'Phone',
            address: 'Billing Address',
        },
        shipping: {
            sectionLabel: 'Shipping',
            method: 'Method',
            pickup: 'Warehouse Pickup',
            customer: 'Ship To',
            easyshipId: 'EasyShip ID',
            label: 'Label',
            labelDownload: 'Download PDF',
            easyshipTrack: 'EasyShip Track',
            liveTracker: 'Live Tracker',
            open: 'Open',
            trackShipment: 'Track Shipment',
        },
        items: {
            sectionLabel: 'Items',
            noItems: 'No items in this order',
            qty: '×',
            total: 'Total',
        },
        status: {
            sectionLabel: 'Order Status',
            updateBtn: 'Update Status',
            updating: 'Updating...',
            successToast: 'Status updated successfully',
            errorToast: 'Failed to update status',
            labels: {
                paid:                'Paid',
                received:            'Received',
                processing:          'Processing',
                ready_for_shipping:  'Ready for Shipping',
                ready_for_pickup:    'Ready for Pickup',
                shipped:             'Shipped',
                picked_up:           'Picked Up',
                delivered:           'Delivered',
                done:                'Done',
                payment_failed:      'Payment Failed',
            },
        },
        print: {
            sectionLabel: 'Print Label',
            printBtn: 'Print Label',
            printing: 'Printing...',
            successToast: 'Label sent to printer',
            errorToast: 'Print failed',
            noLabel: 'No shipping label available',
            buyBtn: 'Buy Label',
            buying: 'Buying...',
            buySuccessToast: 'Label ready',
            buyErrorToast: 'Failed to buy label',
            noShipment: 'No EasyShip shipment on this order',
        },
    },
    he: {
        nav: {
            back: 'חזרה ללוח הניהול',
        },
        hero: {
            eyebrow: 'פרטי הזמנה',
            shipmentId: 'מזהה משלוח',
            notFound: 'הזמנה לא נמצאה',
        },
        meta: {
            customer: 'לקוח',
            date: 'תאריך',
            total: 'סכום',
        },
        customer: {
            sectionLabel: 'לקוח',
            name: 'שם',
            email: 'אימייל',
            phone: 'טלפון',
            address: 'כתובת חיוב',
        },
        shipping: {
            sectionLabel: 'משלוח',
            method: 'שיטת משלוח',
            pickup: 'איסוף מהמחסן',
            customer: 'נשלח אל',
            easyshipId: 'מזהה EasyShip',
            label: 'תווית',
            labelDownload: 'הורד PDF',
            easyshipTrack: 'מעקב EasyShip',
            liveTracker: 'מעקב חי',
            open: 'פתח',
            trackShipment: 'מעקב משלוח',
        },
        items: {
            sectionLabel: 'פריטים',
            noItems: 'אין פריטים בהזמנה',
            qty: '×',
            total: 'סכום',
        },
        status: {
            sectionLabel: 'סטטוס הזמנה',
            updateBtn: 'עדכן סטטוס',
            updating: 'מעדכן...',
            successToast: 'הסטטוס עודכן בהצלחה',
            errorToast: 'עדכון הסטטוס נכשל',
            labels: {
                paid:                'שולם',
                received:            'התקבל',
                processing:          'בעיבוד',
                ready_for_shipping:  'מוכן למשלוח',
                ready_for_pickup:    'מוכן לאיסוף',
                shipped:             'נשלח',
                picked_up:           'נאסף',
                delivered:           'נמסר',
                done:                'הושלם',
                payment_failed:      'תשלום נכשל',
            },
        },
        print: {
            sectionLabel: 'הדפסת תווית',
            printBtn: 'הדפס תווית',
            printing: 'מדפיס...',
            successToast: 'נשלח למדפסת',
            errorToast: 'ההדפסה נכשלה',
            noLabel: 'אין תווית משלוח',
            buyBtn: 'רכוש תווית',
            buying: 'רוכש...',
            buySuccessToast: 'תווית מוכנה',
            buyErrorToast: 'רכישת תווית נכשלה',
            noShipment: 'אין משלוח EasyShip בהזמנה',
        },
    },
};

export function getAdminOrderDetailStrings(language) {
    return adminOrderDetailData[language] || adminOrderDetailData.en;
}

export default adminOrderDetailData;
